const progressPage = {
  "progress.title": "Resumen del progreso",
  "your.progress": "Tu progreso",
  "progress.description": "Cada sesión construye tu historia. Descubre tus fortalezas, debilidades y dónde impulsar tu rendimiento.",
  "progress.byb_iq.explanation":
    "BYB IQ es tu calificación de rendimiento general basada en todas las sesiones del periodo de tiempo seleccionado. Se calcula a partir del promedio de tus cinco métricas y se ajusta según la velocidad del juego, el modo y la complejidad.",

  "progress.section.byb_iq": "Progreso de BYB IQ",
  "progress.section.progress-timeline": "Línea de tiempo del progreso",
  "progress.section.skill-radar": "Radar de habilidades",
  "progress.section.training-streak": "Racha de entrenamiento",
  "progress.section.progress.all_time": "Todo el tiempo",
  "progress.section.progress.past_year": "Últimos 12 meses",
  "progress.section.progress.past_3_months": "Últimos 3 meses",
  "progress.section.progress.past_month": "Últimos mes",
  "progress.section.progress.past_14_days": "Últimos 14 días",
  "progress.section.progress.year": "Progreso anual",
  "progress.section.progress.quarter": "Progreso trimestral",
  "progress.section.progress.month": "Progreso mensual",
  "progress.section.progress.week": "Progreso semanal",
  "progress.section.metric-progress": "Progreso por métrica",
  "progress.section.training-stats": "Estadísticas de Entrenamiento",
  "progress.section.no-data": "¡Aún no hay datos para mostrar!",

  "progress.training-focus.title": "Enfoque de Entrenamiento",
  "progress.training-focus.focus": "Enfócate en {{metric}}: es donde tienes más margen de mejora.",
  "progress.training-focus.empty.title": "Descubramos tu Enfoque de Entrenamiento",
  "progress.training-focus.empty.description": "Analiza tu rendimiento para descubrir dónde tienes más margen de mejora",
  "progress.training-focus.based-on": "Basado en tus últimos 30 días de entrenamiento",
  "progress.training-focus.snackbar": "Configura tu Enfoque de Entrenamiento",
  "progress.training-focus.analyze": "Analizar mi rendimiento",
  "progress.training-focus.improve": "Cómo mejorar",

  "progress.training.streak": "Racha de Entrenamiento",
  "progress.training.streak.days": "Días",
  "progress.training.streak.weeks": "Semanas",
  "progress.training.weekly-training": "Entrenamiento Semanal",
  "progress.training.total-training-time": "Tiempo Total de Entrenamiento",
  "progress.training.avg-session-duration": "Duración Media de Sesión",
  "progress.training.total-sessions": "Total de Sesiones",
  "progress.training.monthly": "Entrenamiento Mensual",
  "progress.training.days": "Días",

  "progress.byb_iq.last_5_sessions": "Últimas 5 sesiones",
  "progress.byb_iq.score": "{{ byb_iq }} BYB IQ",

  "progress.feedback.learning.excellent": "Mejora excepcional — ¡sigue empujando tus límites!",
  "progress.feedback.learning.strong": "Rendimiento consistente — ¡sigue en el camino!",
  "progress.feedback.learning.fair": "Fundamento sólido — sigue construyendo tus habilidades.",
  "progress.feedback.learning.poor": "Etapa temprana — mucho por mejorar.",

  "progress.feedback.performance.excellent": "Nivel élite — mantente alerta y sigue empujando!",
  "progress.feedback.performance.strong": "Rendimiento consistente — ¡sigue en el camino!",
  "progress.feedback.performance.fair": "Esfuerzo decente — pero hay margen de mejora.",
  "progress.feedback.performance.poor": "Impulso perdido — tiempo de resetear y reenfoar.",

  "progress.increase": "aumento",

  "progress.trend.label": "Tendencia de Progreso",
  "progress.trend.explanation":
    "La Tendencia de Progreso es tu impulso a corto plazo y los cambios de rendimiento que comparan tus últimas 10 sesiones con tu promedio en el periodo de tiempo seleccionado.",
  "progress.trend.recent_sessions": "Últimas 5 sesiones vs Promedio",
  "progress.trend.performance.great": "Excelente",
  "progress.trend.performance.refocus": "Reforzar",
  "progress.trend.performance.stable": "Estable",

  "progress.skill-radar.title": "Rendimiento actual",
  "progress.skill-radar.recent": "Reciente",
  "progress.skill-radar.previous": "Anterior",
  "progress.skill-radar.not-available": "No disponible",

  "progress.training-streak.weekly-goal": "Meta semanal",
  "progress.training-streak.weekly": "Esta semana",
  "progress.training-streak.monthly": "Este mes",
  "progress.training-streak.total.time": "Total",
  "progress.training-streak.total.sessions": "Total",

  "progress.bootcamp.description":
    "La pantalla de Progreso realiza un seguimiento de tu rendimiento, métricas y crecimiento a lo largo del tiempo. Aquí verás tu BYB IQ, tendencias de habilidades, estadísticas de entrenamiento y análisis detallados de tu desarrollo.",
  "progress.bootcamp.cta": "¡Vuelve una vez que termines el bootcamp para desbloquear tu panel de progreso completo!",
  "progress.bootcamp.button": "Ir al siguiente desafío del bootcamp",

  "progress.demo.cta": "Esta funcionalidad solo está disponible con una suscripción completa. ¡Actualiza para desbloquearla!",
  "progress.demo.button": "Ir a desafíos",
};

const progressPageMobile = {
  "progress.snapshot.title": "Resumen",
  "progress.performance.title": "Rendimiento",
  "progress.performance.your-performance": "Tu rendimiento",
};

const progressMetrics = {
  "progress.metrics.title": "Tus métricas",
};

const progressCareer = {
  "progress.career.status.progress.base": "{{ divisions }} Divisiones para {{ league }} Liga",
  "progress.career.status.progress.last": "Completa el desafío para alcanzar la {{ league }} Liga",
};

const motivators = {
  "weekly-progress.outcome.excellent-1":
    "Tu esfuerzo la semana pasada realmente dio frutos. ¡Has mostrado un progreso excepcional en todas las métricas!",
  "weekly-progress.outcome.excellent-2": "¡Rendimiento sobresaliente! Tu dedicación a mejorar es claramente visible en los resultados.",
  "weekly-progress.outcome.excellent-3":
    "¡Logro extraordinario! Has establecido nuevos mejores resultados personales y mantenido un rendimiento alto constante.",

  "weekly-progress.outcome.strong-1": "Tu rendimiento superó constantemente los objetivos. ¡Sigue con ese impulso!",
  "weekly-progress.outcome.strong-2": "Buen progreso en general. Tu compromiso con el entrenamiento está dando excelentes resultados.",
  "weekly-progress.outcome.strong-3": "¡Gran rendimiento la semana pasada! Estás desarrollando buenos hábitos de entrenamiento y se nota.",

  "weekly-progress.outcome.fair-1": "Alcanzaste la mayoría de tus objetivos semanales. Enfócate en la constancia para aumentar tu rendimiento.",
  "weekly-progress.outcome.fair-2": "Una semana de entrenamiento equilibrada. Trabajemos para convertir estas sesiones en momentos decisivos.",
  "weekly-progress.outcome.fair-3": "Vas en camino de alcanzar tus metas. Pequeños ajustes pueden generar grandes avances.",

  "weekly-progress.outcome.poor-1": "Cada sesión es una oportunidad para mejorar. Dividamos tus metas en pasos pequeños y alcanzables.",
  "weekly-progress.outcome.poor-2": "Entrenar se trata de progreso a largo plazo. Crea hábitos consistentes y los resultados llegarán.",
  "weekly-progress.outcome.poor-3": "Sigue avanzando. Pequeñas mejoras en cada sesión suman un progreso significativo con el tiempo.",
};

export const progress = {
  ...progressPage,
  ...motivators,
  ...progressPageMobile,
  ...progressMetrics,
  ...progressCareer,
};
